import React, { useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";
import { CSVReader } from 'react-papaparse';
import { GET_SHORTCODES_BY_ORG } from "../../../queries";
//import Sidebar2 from "../../Sidebar2";
import { TitleSource } from "../teleporters/Title";
//import RegisterPropertiesForm from "./Properties/RegisterPropertiesForm";
//import PropertiesProfile from "./Properties/PropertiesProfile";
import ImportList from "./Import/ImportList";

const DataImport = (props:any) => {
    console.log('DataImport props', props);
    let orgId = props.currentUser.orgId; // let { orgId } = useParams();
    console.log('orgId', orgId);

    const [CSVHeaders, setCSVHeaders] = useState<any>(null);
    const [Shortcodes, setShortcodes] = useState<any>([]);
    const [mappedCSVHeaders, setMappedCSVHeaders] = useState<any>(null);

    useEffect(() => {
        loadShortcodes();
    }, []);

    const loadShortcodes = () => {
        var data = {
            org_id: orgId
        };
        props.client.query({
            query: GET_SHORTCODES_BY_ORG,
            variables: data,
            fetchPolicy: "no-cache"
        }).then((result: any) => {
            setShortcodes(transform(result.data));
        });
    }

    const transform = (data: any) => {
        console.log(data)
        let orgShortcodes = data.syncarto_dw_property;
    
        return orgShortcodes.map((item: any, index: any) => {
            return {
                name: item.shortcode,
                id: index
            }
        });
    }

    const handleOnDrop = (data: any) => {
        console.log(data);
        setCSVHeaders(transformFirstRecords(data[0], data)); // First line from papaparse contains headers
        setMappedCSVHeaders(transformFirstRecords(data[0], data, true)); // Keep track of selection in separate array
    };
    
    const transformFirstRecords = (headers: any, data: any, option: boolean = false) => {
        console.log("DataImport > headers", headers)
        console.log("DataImport > data", data)
        console.log("DataImport > option", option)

        let returnableTransformed: any  = [];
        for (var u in headers.data){
            if (option){
                returnableTransformed.push([headers.data[u],data[1].data[u],data[2].data[u],null]);
            }else{
                returnableTransformed.push([headers.data[u],data[1].data[u],data[2].data[u]]);
            } 
        }
        console.log("returnableTransformed", returnableTransformed)
        return returnableTransformed;
    }   

    const handleOnError = (err: any, file: any, inputElem: any, reason: any) => {
        console.log(err);
    };
    
    const handleOnRemoveFile = (data: any) => {
        console.log(data);
    };

    return (
        <div className="m-2-syncarto m-4">
            <TitleSource><h4 className="m-0 mt-1">Data - Import Properties</h4></TitleSource>  

            <Row>
                <Col sm="12">
                    <div className="csv-reader-syncarto">
                        <CSVReader
                            onDrop={handleOnDrop}
                            onError={handleOnError}
                            addRemoveButton
                            onRemoveFile={handleOnRemoveFile}
                            progressBarColor='#0CCDA2'
                            style={{  // https://github.com/Bunlong/react-papaparse/wiki/CSVReader-(Drag-to-Upload)-Style
                                dropArea: {
                                    borderRadius: 0,
                                },
                                fileNameInfo: {
                                    color: '#fff',
                                    backgroundColor: 'none',
                                },
                                fileSizeInfo: {
                                    color: '#fff',
                                    backgroundColor: 'none',
                                },
                                dropFile: {
                                    background: '#6c757d',
                                },
                            }}
                            config={{ // https://react-papaparse.js.org/docs#config
                                delimiter: ",",
                                //quoteChar: "'",
                                //escapeChar: '"'
                            }}
                            >
                            <span>Drop CSV file here or click to upload.</span>
                        </CSVReader>
                    </div>
                </Col>                
                <ImportList 
                    orgId={orgId} 
                    CSVHeaders={CSVHeaders} 
                    Shortcodes={Shortcodes} 
                    mappedCSVHeaders={mappedCSVHeaders} 
                    {...props}
                ></ImportList>
            </Row>  
            {/*{<Sidebar2 width={550} show={showSidebar} onHide={onSidebarHide} >
                {selectedProperty && <PropertiesProfile orgId={orgId} propertyId={selectedProperty} shouldRefreshProperties={shouldRefreshProperties} formOptions={formOptions} {...props}></PropertiesProfile>}
                {showCreateProperty && <RegisterPropertiesForm orgId={orgId} shouldRefreshProperties={shouldRefreshProperties} formOptions={formOptions} {...props}></RegisterPropertiesForm>}
                </Sidebar2>}*/}
        </div>
    );
}

export default DataImport;